import React from 'react';
import ContentLoader from 'react-content-loader';

import Theme from 'styles/theme';

const IMAGE_WIDTH = 300;

const Placeholder = props => (
  <div className="Placeholder">
    <ContentLoader
      height={IMAGE_WIDTH * 1.3}
      width={IMAGE_WIDTH}
      primaryColor={Theme.get('colors-grey')}
      secondaryColor={Theme.get('colors-grey')}
      animate={false}
      {...props}
    >
      <rect x={0} y={0} width={IMAGE_WIDTH} height={IMAGE_WIDTH} />
      <rect
        x={0}
        y={IMAGE_WIDTH + Theme.get('spacing') * 3}
        width={IMAGE_WIDTH / 2}
        height={Theme.get('spacing') * 3}
      />
      <rect
        x={0}
        y={IMAGE_WIDTH + Theme.get('spacing') * 9}
        width={(IMAGE_WIDTH * 2) / 3}
        height={Theme.get('spacing') * 3}
      />
    </ContentLoader>
    <style jsx>
      {`
        .ColorwayCard {
          width: 100%;
          position: relative;
        }
      `}
    </style>
  </div>
);

Placeholder.propTypes = {};

Placeholder.defaultProps = {};

export default Placeholder;
